'use client';

import { memo } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@sola/locales/index.js';
import { i18nConfig } from '@sola/schema/lib/i18n-config.js';

export type TranslationsProviderProps = React.PropsWithChildren & {
  locale?: string;
};
export const TranslationsProvider = memo<TranslationsProviderProps>(
  ({ children, locale }) => {
    if (locale && locale !== i18nConfig.defaultLocale) {
      i18n.loadLanguages([locale]);
    }
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
  },
);
